import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchDetailed(action) {
  try {
    
    const { filtersString } = action.payload;
    const response = yield call(API.fetchTATMonitoringDetailed, filtersString);
    const responseData = response?.data;
    const rawData = responseData?.data || responseData || [];
    const actualData = rawData.map(item => ({
      ...item,
      targetTat: item.tartgetTat || item.targetTat // Map tartgetTat to targetTat
    }));
    

    yield put(actions.fetchDetailedSuccess({ 
      data: actualData
    }));
    
  } catch (error) {
    // Check if the task was cancelled
    if (yield cancelled()) {
      return;
    }
    
    console.error("❌ Saga error:", error);
    yield put(actions.fetchDetailedFailure(error.message || "Failed to load data"));
  }
}

export function* tatMonitoringDetailedSaga() {
  // Use takeLatest to cancel previous requests automatically
  yield takeLatest(actions.fetchDetailed.type, handleFetchDetailed);
}